import React, { FC } from 'react'
import { FormItemProps, SwitchProps as AntSwitchProps } from 'formik-antd'
import { FormItem, Switch as AntSwitch } from '@src/helpers/Formik/formikAntdCompat'

interface SwitchProps extends Omit<AntSwitchProps, 'name'>, Pick<FormItemProps, 'label' | 'name'> {
  required: boolean
}

export const Switch: FC<SwitchProps> = ({ required, name, label, ...props }) => (
  <FormItem labelCol={{ span: 24 }} label={label} name={name} required={required}>
    <AntSwitch name={name} {...props} />
  </FormItem>
)
